export const portfolioItems = [
  {
    id: "1",
    title: "BMBB",
    artist: ["Civeleq", "Hermesdeniz"],
    type: "Co-Produced",
    year: 2026,
    spotifyEmbed: "https://open.spotify.com/embed/track/13IEECituVUiFHK2KAH0op?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/13IEECituVUiFHK2KAH0op?si=168057c277344f75" },
    cover: "https://i.scdn.co/image/ab67616d0000b273c16756359622c8960bd7257b",
  },
  {
    id: "2",
    title: "WIN WIN",
    artist: ["Rabona", "Kerem.", "zateviss"],
    type: "Produced",
    year: 2026,
    spotifyEmbed: "https://open.spotify.com/embed/track/41rSaC1BQjz2otArvOOiXW?autoplay=1",

    credits: "Produced by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/41rSaC1BQjz2otArvOOiXW?si=f036d4cdd66b420b" },
    cover: "https://i.scdn.co/image/ab67616d00001e02a3d7ddff8ce076ad5eadb9b3",
  },
  {
    id: "3",
    title: "HAZIR DEĞİLSİN GALİBA",
    artist: "Rabona",
    type: "Co-Produced",
    year: 2026,
    spotifyEmbed: "https://open.spotify.com/embed/track/35YAcAhbQBf8fhT8aXEBLV?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/35YAcAhbQBf8fhT8aXEBLV?si=996c9ad614c34145" },
    cover: "https://i.scdn.co/image/ab67616d0000b2737e23d23dde05a2bac1b1a3e0",
  },
  {
    id: "4",
    title: "YiRMi26",
    artist: "Civeleq",
    type: "Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/0xtCTLuYDtT9oNIZ83Ht36?autoplay=1",

    credits: "Produced by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/0xtCTLuYDtT9oNIZ83Ht36?si=b7972ed3c6ad487c" },
    cover: "https://i.scdn.co/image/ab67616d0000b273f8eda15fa692f5b515d2a466",
  },
  {
    id: "5",
    title: "A-TRAIN",
    artist: "Rabona",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/4z6TlCTgGouCQQtWXVAwy7?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/4z6TlCTgGouCQQtWXVAwy7?si=15df465f5f2349b3" },
    cover: "https://i.scdn.co/image/ab67616d0000b273bc9b7bbc6ef16cadd207b7cd",
  },
  {
    id: "6",
    title: "Fuck That",
    artist: ["Rabona", "zateviss"],
    type: "Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/3hNYMapkExSeC0TUsvOGkp?autoplay=1",

    credits: "Produced by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/3hNYMapkExSeC0TUsvOGkp?si=43e6d21b919e4109" },
    cover: "https://i.scdn.co/image/ab67616d00001e0208edbce793b51d23049f2191",
  },
  {
    id: "7",
    title: "#GÖZLERİNKATİLİM",
    artist: "Civeleq",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/6Zkq4S0gKZEDJzADF9h8Rx?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/6Zkq4S0gKZEDJzADF9h8Rx?si=b298fbfb1bbd4646" },
    cover: "https://i.scdn.co/image/ab67616d0000b273bc9b7bbc6ef16cadd207b7cd",
  },
  {
    id: "8",
    title: "BINANCE",
    artist: "Rabona",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/2B9Adw8R2gssPyP4bbwROM?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/2B9Adw8R2gssPyP4bbwROM?si=5e4699a2f49e4b7b" },
    cover: "https://i.scdn.co/image/ab67616d00001e02a02801b6f77250e811d63db0",
  },
  {
    id: "9",
    title: "ELİMDE NE KALDI?",
    artist: "Civeleq",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/01sd2LYdDKIpml6VZEBHHl?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/01sd2LYdDKIpml6VZEBHHl?si=a6cb3e4730064d90" },
    cover: "https://i.scdn.co/image/ab67616d00001e02dab9a1a48ccd3097cb7e7816",
  },
  {
    id: "10",
    title: "lanet",
    artist: ["Rabona", "zateviss"],
    type: "Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/1JWlxLrGoZLQWxaq7B23rc?autoplay=1",

    credits: "Produced by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/1JWlxLrGoZLQWxaq7B23rc?si=1fc7fd5065ca46fb" },
    cover: "https://i.scdn.co/image/ab67616d0000b273422b7faeed2d27f4fffca8ac",
  },
  {
    id: "11",
    title: "UYAN",
    artist: "Rabona",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/7zmeduKjADiEOR84Mi3WcD?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/7zmeduKjADiEOR84Mi3WcD?si=3e1ba742b55e41d9" },
    cover: "https://i.scdn.co/image/ab67616d0000b27376e754c14a36bdaa22323bdc",
  },
  {
    id: "12",
    title: "PLACE VAUBAN",
    artist: "LF Scarz",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/3uQXKvpzaTSYrkjvjcaMIQ?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/3uQXKvpzaTSYrkjvjcaMIQ?si=fd0f66d8d9164510" },
    cover: "https://i.scdn.co/image/ab67616d0000b2731591d3ff94a445c50fe9a460",
  },
  {
    id: "13",
    title: "KAFE!N",
    artist: "Civeleq",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/4JPCBDPhaHSGE70IkapiYJ?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/4JPCBDPhaHSGE70IkapiYJ?si=156ab597cd224545" },
    cover: "https://i.scdn.co/image/ab67616d0000b2734391c0fbc4b9248fcef32c39",
  }, {
    id: "14",
    title: "hAyır",
    artist: "Kemal",
    type: "Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/3I3w0O6yUqY7H0IBXXXLMc?autoplay=1",

    credits: "Produced by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/3I3w0O6yUqY7H0IBXXXLMc?si=a6bb2d26c5d6495a" },
    cover: "https://i.scdn.co/image/ab67616d0000b27375ade96b30cd5da1b72f6a37",
  },
  {
    id: "15",
    title: "PRETTY BABY",
    artist: "Rabona",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/5IfIFcm36p2ASIGIAWy6ZY?autoplay=1",

    credits: "Produced by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/5IfIFcm36p2ASIGIAWy6ZY?si=9b5fea72a0954456" },
    cover: "https://i.scdn.co/image/ab67616d0000b273dbb9c2bc4c2cbfd22a5738eb",
  },
  {
    id: "16",
    title: "MEDUSA",
    artist: "Civeleq",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/3d4MKn4yVtpeDO84V8ymgH?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/3d4MKn4yVtpeDO84V8ymgH?si=5796d7e26d20451f" },
    cover: "https://i.scdn.co/image/ab67616d0000b2733622c89b760e31e2fc71c34b",
  },
  {
    id: "17",
    title: "Kaçan Kovalanır",
    artist: "Civeleq",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/2anFNXRk1fkGVGUz7JygRW?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/2anFNXRk1fkGVGUz7JygRW?si=b7e6405a50df4abb" },
    cover: "https://i.scdn.co/image/ab67616d0000b27389af20b7ea63d1b317d3c750",
  },
  {
    id: "18",
    title: "Sebebi Yok",
    artist: "Konuya Fransız",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/1YGqGBmX5R5vvFyxvkirtB?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/1YGqGBmX5R5vvFyxvkirtB?si=2f17f3f176164e64" },
    cover: "https://i.scdn.co/image/ab67616d0000b27379b04676522864dead453e1e",
  },
  {
    id: "19",
    title: "Ah Sen Olmasan",
    artist: "Konuya Fransız",
    type: "Co-Produced",
    year: 2024,
    spotifyEmbed: "https://open.spotify.com/embed/track/4bCHSOrUJyZsN6Ie9Euj3L?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/4bCHSOrUJyZsN6Ie9Euj3L?si=4eb09120878c41a9" },
    cover: "https://i.scdn.co/image/ab67616d0000b2733f6a8c015b9e840d95edab56",
  },
  {
    id: "20",
    title: "Bill Up",
    artist: "LF Scarz",
    type: "Co-Produced",
    year: 2024,
    spotifyEmbed: "https://open.spotify.com/embed/track/4E8sKk5hrcjHGKm0SGPvxy?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/4E8sKk5hrcjHGKm0SGPvxy?si=53f4b5205d85489f" },
    cover: "https://i.scdn.co/image/ab67616d0000b273b1a2e49f9034cfc815999fd7",
  },
  {
    id: "21",
    title: "TOXIC",
    artist: "LF Scarz",
    type: "Co-Produced",
    year: 2024,
    spotifyEmbed: "https://open.spotify.com/embed/track/689FlsFyLqDdTciaQe20S1?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/689FlsFyLqDdTciaQe20S1?si=fb62e492446541eb" },
    cover: "https://i.scdn.co/image/ab67616d0000b2738a51efb47a938d77c8b026b1",
  },
  {
    id: "22",
    title: "LOIN DE PANAME",
    artist: "LF Scarz",
    type: "Co-Produced",
    year: 2024,
    spotifyEmbed: "https://open.spotify.com/embed/track/5PXpjcmPZi0ljpan2x7Tne?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/5PXpjcmPZi0ljpan2x7Tne?si=85148285071e49f8" },
    cover: "https://i.scdn.co/image/ab67616d0000b273f6dd7231f788f2fee583d92c",
  },
  {
    id: "23",
    title: "BTM",
    artist: "LF Scarz",
    type: "Co-Produced",
    year: 2024,
    spotifyEmbed: "https://open.spotify.com/embed/track/3Jko3yqAPwfspo21uIvCW6?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/3Jko3yqAPwfspo21uIvCW6?si=98e69d6c7d8449ee" },
    cover: "https://i.scdn.co/image/ab67616d0000b27387b08b81a1523efa4a4b0c9b",
  },
  {
    id: "24",
    title: "Tempete",
    artist: "LF Scarz",
    type: "Co-Produced",
    year: 2024,
    spotifyEmbed: "https://open.spotify.com/embed/track/3awUDMx9avDuwg9dqZZK8v?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/3awUDMx9avDuwg9dqZZK8v?si=646f2debb40745da" },
    cover: "https://i.scdn.co/image/ab67616d0000b2733611ef9eb003e2856c764ed1",
  },
  {
    id: "25",
    title: "Olurum Beter",
    artist: "Konuya Fransız",
    type: "Co-Produced",
    year: 2024,
    spotifyEmbed: "https://open.spotify.com/embed/track/48cCrX9cc2Ho6k1p7ER3EO?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/48cCrX9cc2Ho6k1p7ER3EO?si=7ee5325e326c4aa2" },
    cover: "https://i.scdn.co/image/ab67616d0000b27329f085dcbda73333d7d55014",
  },
  {
    id: "26",
    title: "YARAMAZ",
    artist: "Civeleq",
    type: "Co-Produced",
    year: 2025,
    spotifyEmbed: "https://open.spotify.com/embed/track/3tIVM3okX2ky6NPMHXaNC1?autoplay=1",

    credits: "Mix & Mastering by Zateviss",
    links: { youtube: "#", spotify: "https://open.spotify.com/intl-tr/track/3tIVM3okX2ky6NPMHXaNC1?si=61dd99f76f8e4a95" },
    cover: "https://i.scdn.co/image/ab67616d00001e027b91fcedf2b0150901a936e7",
  },
];


